<template>
  <div class="faq-page white-theme">
    <div class="container">
      <div class="page-header text-center">
        <span class="section-tag">{{ $t('home.faq.tag') }}</span>
        <h1 class="section-title">{{ $t('home.faq.title') }}</h1>
        <p class="section-subtitle">{{ $t('home.faq.subtitle') }}</p>
      </div>
      <div class="faq-categories">
        <button v-for="c in categories" :key="c.key" :class="['filter-btn', { active: activeCategory === c.key }]" @click="activeCategory = c.key">
          {{ $t(c.labelKey) }}
        </button>
      </div>
      <div class="faq-list">
        <div class="faq-item" v-for="(faq, idx) in filteredFaqs" :key="idx" :class="{ open: openFaq === idx }" @click="toggleFaq(idx)">
          <div class="faq-question">
            <span>{{ $t(faq.qKey) }}</span>
            <svg :class="{ rotated: openFaq === idx }" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="faq-answer" v-show="openFaq === idx">
            <p>{{ $t(faq.aKey) }}</p>
          </div>
        </div>
      </div>
      <div class="faq-contact text-center" style="margin-top:48px;">
        <h3>{{ $t('pricing.questions') }}</h3>
        <p class="text-muted" style="margin-bottom:16px;">{{ $t('pricing.contact') }}</p>
        <a href="mailto:miral_support@miralvis.com" class="btn btn-primary">{{ $t('pricing.contactUs') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      activeCategory: 'all',
      openFaq: null,
      categories: [
        { key: 'all', labelKey: 'faq.categories.all' },
        { key: 'general', labelKey: 'faq.categories.general' },
        { key: 'pricing', labelKey: 'faq.categories.pricing' },
        { key: 'models', labelKey: 'faq.categories.models' },
        { key: 'features', labelKey: 'faq.categories.features' }
      ]
    }
  },
  computed: {
    faqs() { return this.$store.state.faqKeys },
    filteredFaqs() {
      if (this.activeCategory === 'all') return this.faqs
      return this.faqs.filter(f => f.category === this.activeCategory)
    }
  },
  methods: {
    toggleFaq(idx) { this.openFaq = this.openFaq === idx ? null : idx }
  }
}
</script>

<style scoped>
.faq-page { padding: 48px 0 80px; }
.page-header { margin-bottom: 32px; }
.faq-categories { display: flex; gap: 8px; margin-bottom: 32px; justify-content: center; flex-wrap: wrap; }
.filter-btn { padding: 8px 20px; border-radius: var(--radius-full); font-size: 13px; color: var(--text-secondary); border: 1px solid var(--border-color); transition: all 0.2s; }
.filter-btn:hover { border-color: var(--accent); color: var(--text-primary); }
.filter-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); font-weight: 600; }
.faq-list { max-width: 800px; margin: 0 auto; }
.faq-item { border: 1px solid var(--border-color); border-radius: var(--radius-md); margin-bottom: 8px; overflow: hidden; cursor: pointer; transition: border-color 0.2s; }
.faq-item:hover { border-color: var(--border-color); }
.faq-item.open { border-color: var(--accent-border); }
.faq-question { display: flex; align-items: center; justify-content: space-between; padding: 16px 20px; font-size: 15px; font-weight: 500; }
.faq-question svg { transition: transform 0.2s; color: var(--text-muted); flex-shrink: 0; }
.faq-question svg.rotated { transform: rotate(180deg); }
.faq-answer { padding: 0 20px 16px; }
.faq-answer p { font-size: 14px; color: var(--text-secondary); line-height: 1.7; }
</style>
